import { RenewalOfferStatus } from '../../models/Concession'

export const RENEWAL_STATUS_OPTIONS: {
    id: number
    value: RenewalOfferStatus | ''
    label: string
}[] = [
    { id: 0, value: '', label: 'All statuses' },
    { id: 1, value: 'draft', label: 'Draft' },
    { id: 2, value: 'offered', label: 'Offered' },
    { id: 3, value: 'accepted', label: 'Accepted' },
    { id: 4, value: 'declined', label: 'Declined' },
    { id: 5, value: 'transfer_requested', label: 'Transfer requested' },
    { id: 6, value: 'expired', label: 'Expired' },
    { id: 7, value: 'revoked', label: 'Revoked' },
]

export const renewalStatusLabel = (status: RenewalOfferStatus): string => {
    switch (status) {
        case 'draft':
            return 'Draft'
        case 'offered':
            return 'Offered'
        case 'accepted':
            return 'Accepted'
        case 'declined':
            return 'Declined'
        case 'transfer_requested':
            return 'Transfer requested'
        case 'expired':
            return 'Expired'
        case 'revoked':
            return 'Revoked'
        default:
            return status
    }
}

export const renewalStatusColor = (
    status: RenewalOfferStatus,
): 'default' | 'primary' | 'secondary' => {
    switch (status) {
        case 'draft':
            return 'default'
        case 'offered':
            return 'primary'
        case 'accepted':
            return 'primary'
        case 'declined':
        case 'revoked':
        case 'expired':
            return 'secondary'
        case 'transfer_requested':
            return 'default'
        default:
            return 'default'
    }
}

export const formatCurrency = (value: string | number): string => {
    const num = typeof value === 'string' ? parseFloat(value) : value
    if (Number.isNaN(num)) return String(value)
    return num.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
    })
}
